Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _T = require('airbnb-i18n/T');

var _T2 = _interopRequireDefault(_T);

var _airbnbPropTypes = require('airbnb-prop-types');

var _componentWithNamesOfHOCs = require('./componentWithNamesOfHOCs');

var _componentWithNamesOfHOCs2 = _interopRequireDefault(_componentWithNamesOfHOCs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var stringOrTTypes = [_propTypes2['default'].string, (0, _componentWithNamesOfHOCs2['default'])(_T2['default'])];

exports['default'] = (0, _airbnbPropTypes.or)(stringOrTTypes, 'stringOrT');


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/stringOrT.js
// module id = 450
// module chunks = 168707334958949